import { Button, keyframes } from '@chakra-ui/react';
import { Box, Container, Flex, Heading, Image } from '@joinrepublic/dls-ui-kit';

import { containerSize } from '../../config/styles';
import { MotionBox } from '../motion-box/motion-box';
import coverVideo from './assets/cover-video.jpg';
import logoNote from './assets/logo-note.png';
import { COMPANIES } from './data';

const NOTE_VIDEO =
  'https://uploads.republic.com/p/offerings/slider_media_items/contents/original/000/053/912/53912-1768493910-29dda41440a8fed2b3e8868209f658fe0f76404e.webm';

const marqueeAnimation = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

export const RepublicNote = () => {
  return (
    <Box
      as="section"
      id="republic-note"
      position="relative"
      overflow="hidden"
      bg="black"
      color="white"
      isolation="isolate"
    >
      <Container
        maxW={containerSize}
        pt={{ base: '24', sm: '44' }}
        pb={{ base: '24', sm: '36' }}
      >
        <MotionBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
        >
          <Image
            src={logoNote}
            alt="Republic Note"
            mb={{ base: '4', sm: '9' }}
            h={{ base: '6', sm: '8' }}
          />
          <Heading as="h2" size="title-md" color="inherit" mt="0" maxW="830px">
            Invest in one asset—gain access to Republic's evergreen portfolio
            of&nbsp;750+&nbsp;ventures
          </Heading>
          <Button
            as="a"
            href="/note"
            size="md"
            variant="republic-secondary"
            color="white"
            bgColor="transparent"
            mt={{ base: '6', sm: '8' }}
            py="6"
            w="282px"
            _hover={{ color: 'white', borderColor: 'blue.500' }}
            _active={{ bgColor: 'transparent' }}
          >
            Diversify your portfolio
          </Button>
        </MotionBox>
      </Container>

      <MotionBox
        effect="fadeIn"
        viewportMargin="-50px"
        position="relative"
        overflow="hidden"
        pb="12"
        pointerEvents="none"
      >
        <Flex
          animation={{
            base: `${marqueeAnimation} 60s linear infinite`,
            sm: `${marqueeAnimation} 30s linear infinite`,
          }}
          w="max-content"
          opacity="0.6"
        >
          {[...Array(2)].map((_, groupIndex) => (
            <Flex key={groupIndex}>
              {COMPANIES.map(({ company, logo }, index) => (
                <Box
                  as="figure"
                  key={`${groupIndex}-${index}`}
                  px={{ base: '8', sm: '12' }}
                >
                  <Image
                    src={logo}
                    alt={company}
                    h={{ base: '22px', sm: '27px' }}
                  />
                </Box>
              ))}
            </Flex>
          ))}
        </Flex>
      </MotionBox>

      <video
        src={NOTE_VIDEO}
        poster={coverVideo}
        preload="none"
        playsInline
        autoPlay
        muted
        loop
        style={{
          position: 'absolute',
          zIndex: '-1',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: '100%',
          width: '100%',
          objectFit: 'cover',
          pointerEvents: 'none',
        }}
      ></video>
    </Box>
  );
};
